/**
 * 使用开源的第三方库，再自己进行包装
 * 因为这个库本身要侵入 dom，太恶心了，使用起来也各种难用
 */
import Clipboard from 'clipboard';

export const clipboard = ({ copyString, success, error }) => {
  const $mockBtn = document.createElement('button');
  $mockBtn.style = 'display: none';
  const clipboard = new Clipboard($mockBtn, {
    text: () => {
      return copyString;
    }
  });

  clipboard.on('success', (e) => {
    if (typeof success === 'function') {
      success();
    }
    clipboard.destroy();
  });

  clipboard.on('error', (e) => {
    console.log(e)
    if (typeof error === 'function') {
      error();
    }
    clipboard.destroy();
  });

  // 模拟点击一下，触发 clipboard
  $mockBtn.click();
  // 移除掉这个 mock dom
  $mockBtn.remove();
}